<template>
  <div class="card-info">
    <slot name="above-title"></slot>

    <!-- title -->
    <div v-if="showTitle" class="card-info__title__box">
      <div class="d-flex flex-row">
        <div class="card-info__edge-decor"></div>
        <div class="card-info__title__text font-weight-bold">{{ title }}</div>
      </div>
    </div>

    <slot name="below-title"></slot>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },

    showTitle: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<style lang="scss" scoped>
.card-info {
  width: 680px;
  padding: 20px;
  background: #ffffff;
  border: 1px solid #d1d2db;
  box-sizing: border-box;
  box-shadow: 0px 4px 8.8px rgba(166, 166, 185, 0.55);
  border-radius: 10.4px;
}

.card-info__title__box {
  height: 80px;
  padding: 24px;
  background: #ffffff;
  border: 1px solid rgba(122, 123, 151, 0.3);
  box-sizing: border-box;
  border-radius: 10.4px;
}

.card-info__title__text {
  position: absolute;
  font-style: normal;
  font-weight: 500;
  font-size: 21.6px;
  line-height: 32px;
}

.card-info__edge-decor {
  position: absolute;
  margin-left: -27px;
  margin-top: -5px;
  width: 5.28px;
  height: 40px;
  background: #4191ff;
  border-radius: 3px;
}
</style>
